import { useMarketPricePerformance } from '@repo/services'
import { useTranslate } from '@repo/shared/hooks'
import { Card, Col, Row, Separator, Typography } from '@repo/ui/components'
import { Fragment } from 'react'
import { twMerge } from 'tailwind-merge'
import { DashboardMarketSummaryCardItem } from './dashboard.market-summary.card-item'
import { DashboardMarketSummarySkeleton } from './dashboard.market-summary.skeleton'

interface DashboardMarketSummaryProps {
  titleClassName?: string
  isMoreAction?: boolean
  mainClassName?: string
  title?: string
}

export const DashboardMarketSummary = (props: DashboardMarketSummaryProps) => {
  const { mainClassName } = props
  const { t } = useTranslate()
  const { data, isLoading } = useMarketPricePerformance()

  const projects =
    data?.data.projects?.filter((project) => project.kind === 'crypto') || []

  const allData = [
    {
      titleKey: 'dashboard_market_summary_latest',
      items:
        data?.data.newest?.filter(
          (project) =>
            projects.findIndex((p) => p.token === project.symbol) !== -1,
        ) || [],
    },
    {
      titleKey: 'dashboard_market_summary_profitable',
      items:
        data?.data.bests?.filter(
          (project) =>
            projects.findIndex((p) => p.token === project.symbol) !== -1,
        ) || [],
    },
    // {
    //   titleKey: 'dashboard_market_summary_most_sold',
    //   items: data?.data.worst || [],
    // },
  ]

  return (
    <Col className={twMerge('gap-xs w-full mt-sm', mainClassName)}>
      {isLoading ? (
        <DashboardMarketSummarySkeleton />
      ) : (
        <Row className='gap-sm items-start md:gap-lg w-full flex-wrap'>
          {allData.map((card) => (
            <Card
              key={card.titleKey}
              className='!p-0 w-full sm:flex-1 min-h-[355px]'
              style={{
                boxShadow:
                  '0px 2px 8px -2px var(--color-black-5), 0px 1px 2px 0px var(--color-black-5)',
              }}
            >
              <Typography size='sm' weight='bold' className='p-md pb-xs'>
                {t(card.titleKey as keyof typeof t)}
              </Typography>
              <Col>
                {card?.items?.slice(0, 3)?.map((item, i) => (
                  <Fragment key={i}>
                    {i > 0 && <Separator />}
                    <DashboardMarketSummaryCardItem
                      {...item}
                      projects={projects}
                    />
                  </Fragment>
                ))}
              </Col>
            </Card>
          ))}
        </Row>
      )}
    </Col>
  )
}
